import { render } from "./ProjectAutoReply.vue?vue&type=template&id=72890a86&scoped=true"
import script from "./ProjectAutoReply.vue?vue&type=script&lang=js"
export * from "./ProjectAutoReply.vue?vue&type=script&lang=js"

import "./ProjectAutoReply.vue?vue&type=style&index=0&id=72890a86&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72890a86"]])

export default __exports__